<template>
  <div class="stock-store">
    <van-nav-bar
      title="原料管理"
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <div class="top-nav-bar" @click.stop="createRaw">
          +添加原料
        </div>
      </template>
    </van-nav-bar>
    <wh-mobile-list ref="listTable" class="main" :extra-params="extraParams" data-src="/api/getRawMaterialsStockList">
      <template v-slot="{list}">
        <van-cell v-for="i in list" :key="i.id" is-link @click="toInfo(i)">
          <template #title>
            <div class="list-item">
              <span>{{ i.materialName }}</span>
              <span>{{ i.quantity }} {{ i.materialUnit }}</span>
            </div>
          </template>
        </van-cell>
      </template>
    </wh-mobile-list>
    <stock-store-popup
      :visible.sync="popup.store.visible"
      :form-type="popup.store.formType"
      :init-form-data="popup.store.initFormData"
      @submitFormSuccess="submitFormSuccessFn"
    />
  </div>
</template>
<script>
import { formatTime } from '@/utils/convert/convertTime'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import StockStorePopup from '@/views/StockStore/components/StockStorePopup'
export default {
  components: { WhMobileList, StockStorePopup },
  data() {
    return {
      popup: {
        store: {
          visible: false,
          formType: 'create',
          initFormData: {}
        }
      },
      extraParams: {

      }
    }
  },
  methods: {
    formatTime,
    onClickLeft() {
      this.$router.go(-1)
    },
    toInfo(i) {
      this.$router.push({
        name: 'StockStoreInfo',
        params: {
          id: i.id
        }
      })
    },
    createRaw() {
      this.popup.store.visible = true
      this.popup.store.formType = 'create'
    },
    submitFormSuccessFn(flag) {
      if (flag) {
        this.$refs.listTable.onRefresh()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.stock-store{
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #F6F5F5;
  .top-nav-bar{
    color: #20CAA0;
  }
  .main{
    padding: 6px 0 0;
    .list-item{
      display: flex;
      >span:first-child{
        width: 80px;
      }
      >span:last-child{
        color: #20CAA0;
        margin-left: 20px;
      }
    }
  }
}
</style>
